import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { Mis12 } from "./mis12";
import { HTTP_METHODS, invokeApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { Mis24 } from "./mis24";

const Mis = () => {
  const [misDetails, setMisDetails] = useState({});

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.MIS_CHART_DATA}`, null)
      .then((response) => {
        setMisDetails(response);
      })
      .catch((err) => console.error(err));
  };
  return (
    <div className="page-body">
      <Box sx={{ width: "100%" }} spacing={2}>
        <Grid container md={12} sx={{ mb: 2 }}>
          <Grid item sm={12}>
            <Card>
              <CardContent>
                <Typography variant="h6">MIS 12 </Typography>
                <Mis12 data={misDetails.mis12 || {}} />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid container md={12}>
          <Grid item sm={12}>
            <Card>
              <CardContent>
                <Typography variant="h6">MIS 24 </Typography>
                <Mis24 data={misDetails.mis24 || {}} />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default Mis;
